import SPCards from './SPCards'

export default SPCards
